
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import { NavigateFunction } from 'react-router-dom';

export const handleAuthRedirect = async (
  locationHash: string,
  locationPathname: string,
  setLoading: (loading: boolean) => void,
  setSession: (session: any) => void,
  setUser: (user: any) => void,
  navigate: NavigateFunction
): Promise<void> => {
  if (locationHash && locationHash.includes('access_token')) {
    setLoading(true);
    console.log('Processing auth redirect with token in URL hash');
    
    try {
      // Get the current session which will include the token from the hash
      const { data, error } = await supabase.auth.getSession();
      
      if (error) {
        console.error('Error processing auth redirect:', error);
        toast.error('Authentication failed');
        setLoading(false);
        return;
      }
      
      if (data?.session) {
        console.log('Successfully established session from redirect');
        setSession(data.session);
        setUser(data.session.user);
        toast.success(`Welcome, ${data.session.user.email}`);
        
        // Clear the hash from the URL to avoid issues on page refresh
        window.history.replaceState(null, document.title, window.location.pathname);
        
        // Force navigation to teams with replace to prevent back button issues
        // Add a small delay to ensure state is updated before navigation
        setTimeout(() => {
          navigate('/teams', { replace: true });
          setLoading(false);
        }, 500);
      } else {
        setLoading(false);
      }
    } catch (error) {
      console.error('Error in auth redirect handling:', error);
      toast.error('Failed to complete authentication');
      setLoading(false);
    }
  } else {
    // No hash with tokens, just check for existing session normally
    const { data } = await supabase.auth.getSession();
    setSession(data.session);
    setUser(data.session?.user ?? null);
    setLoading(false);
    
    // If we have a session but we're on the auth page, redirect to teams
    if (data.session && locationPathname === '/auth') {
      navigate('/teams', { replace: true });
    }
  }
};
